<template>
  <div>
    <div class="col-md-12 m-0 p-0">
      <b-table sticky-header :fields="labels" :items="data"></b-table>
      <div class="text-right">
        <vue-json-to-csv
          :json-data="data"
          :labels="csvLabel"
          @error="(val) => errors(val)"
          :csv-title="'expired_booking_report'"
        >
          <b-button variant="outline-primary">
            <p class="m-0 p-0">EXPORT TO CSV</p>
          </b-button>
        </vue-json-to-csv>
      </div>
    </div>
  </div>
</template>

<script>
import VueJsonToCsv from "vue-json-to-csv";
export default {
  data() {
    return {
      csvLabel: {
        bookingId: { title: "ID" },
        registrationNumber: { title: "Registration No" },
        modelName: { title: "Make/Model" },
        customerName: { title: "Customer Name" },
        customerMobile: { title: "Customer Phone" },
        customerEmail: { title: "Customer Email" },
        startDateFormatted: { title: "Start Date" },
        endDateFormatted: { title: "End Date" },
        rentalCharge: { title: "Per Month Rental" },
        expiredDays: { title: "Expired Days" },
        perDayRental: { title: "Rental Penalty (per day)" },
        bookingPenalty: { title: "Total Rental Penalty per day(RP)" },
        perDayPenalty: { title: "Penalty per day (PPD) (100/day)" },
        helmetPenalty: { title: "Helmet Penalty (HP) (50/months)" },
        totalPenalty: { title: "Payable Penalty (RP+PPD+HP)" },
      },
      labels: [
        { key: "bookingId", label: "ID" },
        { key: "registrationNumber", label: "Registration No" },
        { key: "modelName", label: "Make/Model" },
        { key: "customerName", label: "Customer Name" },
        { key: "customerMobile", label: "Customer Phone" },
        { key: "customerEmail", label: "Customer Email" },
        { key: "startDateFormatted", label: "Start Date" },
        { key: "endDateFormatted", label: "End Date" },
        { key: "rentalCharge", label: "Per Month Rental" },
        { key: "expiredDays", label: "Expired Days" },
        { key: "perDayRental", label: "Rental Penalty (per day)" },
        { key: "bookingPenalty", label: "Total Rental Penalty per day(RP)" },
        { key: "perDayPenalty", label: "Penalty per day (PPD) (100/day)" },
        { key: "helmetPenalty", label: "Helmet Penalty (HP) (50/months)" },
        { key: "totalPenalty", label: "Payable Penalty (RP+PPD+HP)" },
      ],
    };
  },
  props: {
    data: Array,
    label: String,
  },
  components: {
    VueJsonToCsv,
  },
};
</script>

<style></style>
